<div class="col-md-12 mb-30" *ngIf="Selected_Funds_Record_Switcher=='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">User Petty Cash List</h5>
      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Username</label>
          <input [(ngModel)]="Filter_Username" (keyup)="Change_Filter()" name="Filter_title" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Name </label>
          <input [(ngModel)]="Filter_Name" (keyup)="Change_Filter()" name="Filter_title" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Last Name </label>
          <input [(ngModel)]="Filter_Familly" (keyup)="Change_Filter()" name="Filter_title" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_User()" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
          <button *ngIf="!Procssing" (click)="exportexcel_Funds()" type="button" class="btn btn-warning"
            style="margin-right: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Last Name</th>
              <th>Username</th>
              <th>Balance (IRR)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_User
            |filter:Filter_Name:'name'
            |filter:Filter_Familly:'familly'
            |filter:Filter_Username:'username'
            | paginate
                    : {
                        id: 'DataList_UserTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_User
                        |filter:Filter_Name:'name'
                        |filter:Filter_Familly:'familly'
                        |filter:Filter_Username:'username'
                        ).length
                      }
            ">
              <td>{{DataList_User.indexOf(item)+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.familly}}</td>
              <td>{{item.username}}</td>
              <td style="direction: ltr;">{{item.funds|number}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;" class="dropdown-item" (click)="Set_Form_Funds_View(item,'Form')"><i
                          class="fa  fa-user-plus"></i>Balance</a>
                    </div>
                  </div>

                  <div *ngIf="item.DeletingProccess">
                    <img src="assets/Loading.gif" style="width: 25px;" />
                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>

    </div>

    <pagination-controls id="DataList_UserTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>

  </div>
</div>

<div class="col-md-12 mb-30" *ngIf="Selected_Funds_Record_Switcher=='Form'">
  <app-FundsForm [inner_User]="Selected_Funds_Record">
  </app-FundsForm>

  <button (click)="Set_List_Funds_View()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back
  </button>

</div>


<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>Name</th>
      <th>Last Name</th>
      <th>Username</th>
      <th>Balance (IRR)</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_User">
      <td>{{DataList_User.indexOf(item)+1}}</td>
      <td>{{item.name}}</td>
      <td>{{item.familly}}</td>
      <td>{{item.username}}</td>
      <td style="direction: ltr;">{{item.funds|number}}</td>
    </tr>
  </tbody>
</table>